module.exports = __webpack_public_path__ + "img/invoice-de-female-wm-be.81707a8b.png";